setTimeout(() => {
  const testEl = document.querySelector('#predictive-search-results');
  if (testEl) {
    testEl.innerHTML = '<div style="padding:2rem; font-size:18px;">🔍 Predictive-Suchfeld sichtbar</div>';
  } else {
    console.log('❌ Kein Element mit #predictive-search-results gefunden');
  }
}, 2000);

console.log('✅ Predictive Search JS wurde geladen');

window.addEventListener('load', () => {
  const input = document.querySelector('#Search');
  const resultsContainer = document.querySelector('#predictive-search-results');
  const clearButton = document.querySelector('#clear-search-button');

  if (!input || !resultsContainer || !clearButton) return;

  input.addEventListener('input', () => {
    clearButton.style.display = input.value.length > 0 ? 'inline-block' : 'none';
  });

  clearButton.addEventListener('click', () => {
    input.value = '';
    resultsContainer.innerHTML = '';
    resultsContainer.hidden = true;
    clearButton.style.display = 'none';
    input.focus();
  });

  let controller;

  input.addEventListener('input', async () => {
    const synonymMap = {
      "steinkrug": "bierkrug",
      "glaskrug": "bierkrug",
      "häferl": "tasse",
      "kaffeebecher": "tasse",
      "bierbecher": "bierkrug",
      "seidel": "bierkrug",
      "becher": "tasse",
      "teller": "glasartikel",
      "untersetzer": "glasartikel",
      "aschenbecher": "glasartikel",
      "gläser": "glasartikel",
      "glas": "glasartikel",
      "hut": "cap",
      "cappy": "cap",
      "mütze": "cap",
      "sticker": "aufkleber",
      "pickerl": "aufkleber",
      "patch": "aufnäher",
      "abzeichen": "aufnäher",
      "schild": "autoschild",
      "kennzeichen": "autoschild",
      "kfz-schild": "autoschild",
      "kuckuck": "kuckucksuhr",
      "kuckucksuhr": "kuckucksuhr",
      "wanduhr": "kuckucksuhr",
      "souveniruhr": "kuckucksuhr",
      "geschenk": "souvenir",
      "andenken": "souvenir",
      "erinnerung": "souvenir",
      "flagge": "deutschland",
      "fahne": "deutschland",
      "germany": "deutschland",
      "krüge": "bierkrug",
      "tassen": "tasse",
      "caps": "cap",
      "mützen": "cap"
    };

    function normalizeQuery(query, synonyms) {
      const words = query.toLowerCase().split(/\s+/);
      return words.map(word => synonyms[word] || word).join(" ");
    }

    const rawQuery = input.value.trim();
    const query = normalizeQuery(rawQuery, synonymMap);

    if (controller) controller.abort();
    controller = new AbortController();

    try {
      const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=15`, {
        signal: controller.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      const data = await res.json();
      const products = data.resources.results.products;

      resultsContainer.hidden = false;

      if (!products || products.length === 0) {
        resultsContainer.innerHTML = `<div style="padding:2rem; font-size:18px;">❌ Keine passenden Produkte gefunden.</div>`;
        return;
      }

      resultsContainer.innerHTML = `
        <div style="display: flex; width: 100%; padding: 1.5rem 1rem; box-sizing: border-box; gap: 2.5rem; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;">

          <!-- Linke Spalte -->
          <aside style="width: 280px; flex-shrink: 0; border-right: 1px solid #e0e0e0; padding-right: 2rem;">
            <h3 style="font-weight: 700; font-size: 15px; margin-bottom: 1.2rem; text-transform: uppercase;">Beliebte Kategorien</h3>
            <ul style="list-style: none; padding-left: 0; margin: 0 0 2.5rem 0; font-size: 18px; line-height: 1.6;">
              <li><a href="/collections/magnete">Magnete</a></li>
              <li><a href="/collections/schlusselkette">Schlüsselketten</a></li>
              <li><a href="/collections/aufkleber">Aufkleber & Aufnäher</a></li>
              <li><a href="/collections/autoschilder">Autoschilder</a></li>
              <li><a href="/collections/caps-hute">Caps & Hüte</a></li>
              <li><a href="/collections/seidel-glasartikel">Seidel & Glasartikel</a></li>
              <li><a href="/collections/bierkruge-tassen">Bierkrüge & Tassen</a></li>
              <li><a href="/collections/kuckucksuhr-uhr">Uhren & Kuckucksuhren</a></li>
            </ul>

            <h3 style="font-weight: 700; font-size: 15px; margin-bottom: 1.2rem; text-transform: uppercase;">Service</h3>
            <ul style="list-style: none; padding-left: 0; margin: 0; font-size: 18px; line-height: 1.6;">
              <li><a href="/pages/kontakt">Kontakt</a></li>
              <li><a href="#">FAQ</a></li>
              <li><a href="/pages/uber-uns">Über Uns</a></li>
              <li><a href="/pages/newsletter">Newsletter & Aktionen</a></li>
              <li><a href="/blogs/news">Blog-Artikel</a></li>
            </ul>
          </aside>

          <!-- Rechte Spalte -->
          <section style="flex: 1;">
            <h3 style="font-size: 20px; font-weight: 700; margin-bottom: 1.5rem;">Ergebnisse</h3>
            <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 2rem;">
              ${products.map(p => `
                <a href="${p.url}" style="text-align: left; text-decoration: none; color: inherit; display: block;">
                  <img src="${p.image || 'https://via.placeholder.com/160x160?text=Kein+Bild'}" alt="${p.title}" style="width: 160px; height: auto; object-fit: contain; margin-bottom: 0.75rem;" loading="lazy">
                  <div style="font-weight: 600; font-size: 17px; margin-bottom: 0.25rem;">${p.title}</div>
                  <div style="font-size: 15px; color: #888; margin-bottom: 0.25rem;">${p.category || ''}</div>
                  <div style="color: #000; font-weight: 700; font-size: 15px;">
                    ${parseFloat(p.price).toFixed(2).replace('.', ',')} €
                  </div>
                </a>
              `).join('')}
            </div>
          </section>
        </div>
      `;
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error('Suchfehler:', err);
      }
    }
  });

  // Klickschutz für Ergebnisfeld
  resultsContainer.addEventListener('click', (e) => e.stopPropagation());
  document.addEventListener('click', (e) => {
    const isClickInside = resultsContainer.contains(e.target) || input.contains(e.target);
    if (!isClickInside) {
      resultsContainer.hidden = true;
    }
  });
});
